export enum TemplateVersioningStep {
  REVIEW = "review",
  PUBLISH = "publish",
}
